/* LUMIS – Scripts de las secciones MT (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    if (!format) return withComma + ' €';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_with_comma_separator') return withComma;
      if (key === 'amount_no_decimals_with_comma_separator') return withComma.split(',')[0];
      if (key === 'amount_no_decimals') return withDot.split('.')[0];
      return withDot;
    });
  }

  /* ---------- Reveals + cifras animadas (un solo observer) ---------- */
  var io = null;
  function countUp(el) {
    var target = parseFloat(String(el.dataset.count).replace(',', '.'));
    if (isNaN(target) || reduced) return;
    var decimals = (String(el.dataset.count).split(/[.,]/)[1] || '').length;
    var prefix = el.dataset.prefix || '';
    var suffix = el.dataset.suffix || '';
    var start = null;
    var dur = 1600;
    function frame(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + (target * eased).toFixed(decimals).replace('.', ',') + suffix;
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible), [data-count]:not([data-counted])');
    if (!els.length) return;
    function activate(el) {
      if (el.hasAttribute('data-count')) { el.setAttribute('data-counted', '1'); countUp(el); }
      else el.classList.add('mt-visible');
    }
    if (!('IntersectionObserver' in window)) { els.forEach(activate); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { activate(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    if (reduced) return;
    var items = document.querySelectorAll('[data-mt-parallax]');
    if (!items.length) return;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var k = parseFloat(el.dataset.mtParallax) || 0;
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        el.style.transform = 'translate3d(0,' + (-r.top * k / 100).toFixed(1) + 'px,0) scale(' + (1 + k / 200) + ')';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Comparador antes/después ---------- */
  function initCompare() {
    document.querySelectorAll('[data-mt-compare]').forEach(function (c) {
      if (c.dataset.mtInit) return;
      c.dataset.mtInit = '1';
      var range = c.querySelector('input[type=range]');
      if (!range) return;
      function set() { c.style.setProperty('--pos', range.value + '%'); }
      range.addEventListener('input', set);
      set();
    });
  }

  /* ---------- Galería ---------- */
  function initGallery(root) {
    var gallery = root.querySelector('[data-mt-gallery]');
    if (!gallery) return null;
    var slides = gallery.querySelectorAll('.mt-gallery__slide');
    var thumbs = gallery.querySelectorAll('.mt-gallery__thumb');
    var current = 0;
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === current); });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === current);
        t.setAttribute('aria-current', n === current ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = gallery.querySelector('.mt-gallery__nav--prev');
    var next = gallery.querySelector('.mt-gallery__nav--next');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    var startX = null;
    var main = gallery.querySelector('.mt-gallery__main');
    main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      startX = null;
    });
    return {
      showMedia: function (mediaId) {
        slides.forEach(function (s, n) { if (s.dataset.mediaId === String(mediaId)) show(n); });
      }
    };
  }

  /* ---------- Entrega estimada ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function initDelivery(root) {
    var el = root.querySelector('[data-mt-delivery]');
    if (!el) return;
    var min = parseInt(el.dataset.min, 10) || 2;
    var max = parseInt(el.dataset.max, 10) || 4;
    var cutoff = parseInt(el.dataset.cutoff, 10);
    var now = new Date();
    var start = now;
    if (!isNaN(cutoff) && now.getHours() >= cutoff) start = addBusinessDays(now, 1);
    var fmt = { weekday: 'long', day: 'numeric', month: 'long' };
    var from = el.querySelector('[data-mt-from]');
    var to = el.querySelector('[data-mt-to]');
    if (from) from.textContent = addBusinessDays(start, min).toLocaleDateString('es-ES', fmt);
    if (to) to.textContent = addBusinessDays(start, max).toLocaleDateString('es-ES', fmt);
  }

  /* ---------- Producto: packs + carrito de Dawn ---------- */
  function initProduct(root) {
    var form = root.querySelector('[data-mt-form]');
    if (!form || root.dataset.mtInit) return;
    root.dataset.mtInit = '1';
    var gallery = initGallery(root);
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var moneyFormat = root.dataset.moneyFormat;
    var packs = root.querySelectorAll('.mt-pack');
    var addBtn = form.querySelector('[data-mt-add]');
    var buyBtn = form.querySelector('[data-mt-buy]');
    var errorEl = form.querySelector('[data-mt-error]');
    var sticky = document.querySelector('[data-mt-sticky="' + root.dataset.section + '"]');
    var stickyPrice = sticky ? sticky.querySelector('[data-mt-sticky-price]') : null;
    var addLabel = addBtn ? addBtn.dataset.label : '';
    var soldLabel = addBtn ? addBtn.dataset.soldout : '';

    function select(pack) {
      packs.forEach(function (p) {
        var on = p === pack;
        p.classList.toggle('is-selected', on);
        var input = p.querySelector('input');
        if (input) input.checked = on;
      });
      idInput.value = pack.dataset.variant;
      if (qtyInput) qtyInput.value = pack.dataset.qty || 1;
      var available = pack.dataset.available === 'true';
      [addBtn, buyBtn].forEach(function (b) { if (b) b.disabled = !available; });
      if (addBtn) addBtn.querySelector('span').textContent = available ? addLabel : soldLabel;
      if (stickyPrice) stickyPrice.textContent = formatMoney(parseInt(pack.dataset.total, 10), moneyFormat);
      if (gallery && pack.dataset.media) gallery.showMedia(pack.dataset.media);
    }
    packs.forEach(function (p) {
      p.addEventListener('click', function (e) { e.preventDefault(); select(p); });
      p.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(p); }
      });
    });

    function addToCart(goToCheckout) {
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      var btn = goToCheckout ? buyBtn : addBtn;
      if (btn) btn.classList.add('is-loading');
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var items = [{ id: Number(idInput.value), quantity: Number(qtyInput ? qtyInput.value : 1) }];
      var sel = root.querySelector('.mt-pack.is-selected');
      if (sel && sel.dataset.extraVariant && Number(sel.dataset.extraQty) > 0) {
        items.push({ id: Number(sel.dataset.extraVariant), quantity: Number(sel.dataset.extraQty) });
      }
      var body = { items: items };
      var limId = root.dataset.limiteId, limCant = parseInt(root.dataset.limiteCantidad, 10);
      var comprobar = (limId && limCant) ? fetch(rootUrl + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var yaHay = 0;
        c.items.forEach(function (it) { if (String(it.product_id) === String(limId)) yaHay += it.quantity; });
        var nuevo = 0;
        items.forEach(function (it) { if (String(it.id) === String(idInput.value)) nuevo += it.quantity; });
        if (yaHay + nuevo > limCant) throw new Error(root.dataset.limiteMsg || ('Máximo ' + limCant + ' unidades por pedido.'));
      }) : Promise.resolve();
      if (cart && !goToCheckout && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      return comprobar.then(function () { return fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }); })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || 'Error');
          if (goToCheckout) { window.location.href = rootUrl + 'checkout'; return; }
          if (cart && res.sections && typeof cart.renderContents === 'function') {
            // Dawn espera el formato de respuesta de un único producto
            var item = (res.items && res.items[0]) || {};
            item.sections = res.sections;
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(item);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mt-producto', productVariantId: idInput.value, cartData: res });
            }
          } else {
            window.location.href = rootUrl + 'cart';
          }
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          else window.location.href = rootUrl + 'cart';
        })
        .finally(function () { if (btn) btn.classList.remove('is-loading'); });
    }

    // Precio correcto en la barra fija desde el principio
    var inicial = root.querySelector('.mt-pack.is-selected');
    if (inicial && stickyPrice) stickyPrice.textContent = formatMoney(parseInt(inicial.dataset.total, 10), moneyFormat);

    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(false); });
    if (buyBtn) buyBtn.addEventListener('click', function (e) { e.preventDefault(); addToCart(true); });

    if (sticky) {
      var stickyBtn = sticky.querySelector('[data-mt-sticky-btn]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (addBtn && !addBtn.disabled) addToCart(false);
      });
      var target = addBtn || form;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var below = e.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', !e.isIntersecting && below);
          });
        }).observe(target);
      }
    }
  }

  /* ---------- Carruseles ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-mt-carousel]').forEach(function (c) {
      if (c.dataset.mtInit) return;
      c.dataset.mtInit = '1';
      var track = c.querySelector('.mt-carousel__track');
      var prev = c.querySelector('[data-mt-prev]');
      var next = c.querySelector('[data-mt-next]');
      function step() {
        var item = track.querySelector('.mt-carousel__item');
        return item ? item.getBoundingClientRect().width + 18 : track.clientWidth;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      // Reproducir vídeos al tocarlos
      c.querySelectorAll('video').forEach(function (v) {
        v.addEventListener('click', function () {
          var play = v.parentElement.querySelector('.mt-carousel__play');
          if (v.paused) { v.play(); if (play) play.style.display = 'none'; }
          else { v.pause(); if (play) play.style.display = ''; }
        });
      });
    });
  }

  /* ---------- Reseñas: "ver más" ---------- */
  function initReviews() {
    document.querySelectorAll('[data-mt-reviews]').forEach(function (wrap) {
      var btn = wrap.querySelector('[data-mt-more]');
      if (!btn || btn.dataset.mtInit) return;
      btn.dataset.mtInit = '1';
      btn.addEventListener('click', function () {
        wrap.querySelectorAll('.mt-rev__card[hidden]').forEach(function (c) { c.hidden = false; });
        btn.parentElement.remove();
      });
    });
  }

  /* ---------- Cuenta atrás (fin de oferta real / envío hoy) ---------- */
  function horaMadrid() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var dias = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return { dia: p.weekday, wd: dias.indexOf(p.weekday), seg: (parseInt(p.hour, 10) % 24) * 3600 + parseInt(p.minute, 10) * 60 + parseInt(p.second, 10) };
  }
  function initCountdowns() {
    document.querySelectorAll('[data-mt-countdown]').forEach(function (el) {
      if (el.dataset.mtInit) return;
      el.dataset.mtInit = '1';
      var modo = el.dataset.modo, fin = parseInt(el.dataset.fin, 10) * 1000, corte = parseInt(el.dataset.corte, 10) || 16;
      var cajaD = el.querySelector('[data-u="d"]');
      var titulo = el.querySelector('.mt-contador__titulo');
      var plantilla = titulo ? titulo.textContent : '';
      function pinta(ms) {
        var t = Math.max(0, Math.floor(ms / 1000));
        var d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600), m = Math.floor(t % 3600 / 60), s = t % 60;
        cajaD.querySelector('b').textContent = String(d).padStart(2, '0');
        cajaD.style.display = d > 0 ? '' : 'none';
        el.querySelector('[data-u="h"]').textContent = String(h).padStart(2, '0');
        el.querySelector('[data-u="m"]').textContent = String(m).padStart(2, '0');
        el.querySelector('[data-u="s"]').textContent = String(s).padStart(2, '0');
      }
      function tick() {
        var restante;
        if (modo === 'oferta') {
          restante = fin - Date.now();
        } else {
          var mad = horaMadrid();
          var nombres = ['EL DOMINGO', 'EL LUNES', 'EL MARTES', 'EL MIÉRCOLES', 'EL JUEVES', 'EL VIERNES', 'EL SÁBADO'];
          for (var i = 0; i < 8; i++) {
            var wd = (mad.wd + i) % 7;
            if (wd === 0 || wd === 6) continue;
            if (i === 0 && mad.seg >= corte * 3600) continue;
            restante = (i * 86400 + corte * 3600 - mad.seg) * 1000;
            var etiqueta = i === 0 ? 'HOY' : (i === 1 ? 'MAÑANA' : nombres[wd]);
            if (titulo && plantilla) titulo.textContent = plantilla.replace('{dia}', etiqueta);
            break;
          }
        }
        if (!(restante > 0)) { el.hidden = true; return false; }
        el.hidden = false;
        pinta(restante);
        return true;
      }
      if (tick()) {
        var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-mt-product]').forEach(function (root) {
      initProduct(root);
      initDelivery(root);
    });
    initCarousels();
    initReviews();
    initCompare();
    initCountdowns();
    initReveals();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); initParallax(); });
  else { init(); initParallax(); }
  document.addEventListener('shopify:section:load', init);
})();
